import { Box } from "@mui/material";
import type React from "react";
import { useLocation } from "react-router";
import {
	FOOTER_HEIGHT,
	HEADER_HEIGHT,
	NAVIGATION_HEIGHT,
	SIDEMENU_WIDTH,
} from "@/config/constants";
import type { ContentType } from "@/shared/types";
import { getSelectedContentByPath } from "@/shared/utils";
import { Footer } from "./Footer";
import { Header } from "./Header";
import { Navigation } from "./Navigation";
import { SideMenu } from "./SideMenu";

export interface DefaultLayoutProps {
	children: React.ReactNode;
	selectedContent: ContentType;
}

export function DefaultLayout({ children }: DefaultLayoutProps) {
	const location = useLocation();
	const pathname = location.pathname;
	const selectedContent = getSelectedContentByPath(pathname);
	const isHome = pathname === "/";
	const showSideMenu = !isHome;

	return (
		<Box
			sx={{
				height: "100vh",
				width: "100vw",
				display: "grid",
				gridTemplateColumns: showSideMenu ? `${SIDEMENU_WIDTH}px auto` : "auto",
				gridTemplateRows: `${HEADER_HEIGHT}px ${NAVIGATION_HEIGHT}px auto ${FOOTER_HEIGHT}px`,
				gridTemplateAreas: showSideMenu
					? `
					"header header"
					"navigation navigation"
					"sidemenu main"
					"sidemenu footer"
				`
					: `
					"header"
					"navigation"
					"main"
					"footer"
				`,
			}}
		>
			{/* ヘッダー */}
			<Header />
			<Navigation />
			{/* メイン */}

			{showSideMenu && <SideMenu selectedContent={selectedContent} />}
			<Box
				component={"main"}
				sx={{
					gridArea: "main",
					overflow: "auto", // 縦横スクロール許可
					maxHeight: `calc(100vh - ${HEADER_HEIGHT + NAVIGATION_HEIGHT + FOOTER_HEIGHT}px)`,
				}}
			>
				<Box sx={{ m: 2, mt: 4, minWidth: "600px" }}>
					{/* <PageHeader sx={{ m: 2 }} /> */}
					{children}
				</Box>
			</Box>
			{/* フッター */}
			<Footer />
		</Box>
	);
}
